/** Formato persistido e exibido por uma constante numérica no editor de fórmulas. */
export enum TipoConstanteNumericaEnum {
    Decimal = 1,
    Inteiro = 2,
}
